export default __webpack_public_path__ + "static/media/case-summaries.7fb4f91a.webp";